import(/* webpackMode: "eager", webpackExports: ["FaleConoscoModal"] */ "/home/vsts/work/1/s/components/footer/_components/fale-conosco-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/vsts/work/1/s/components/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/components/product-differentials/_components/product-differentialsmain.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/components/product-hero/_components/form/interest-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/components/rede-credenciada/rede-credenciada.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/components/whatsapp/whatsapp.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/font/local/target.css?{\"path\":\"app/tag-com-beneficios-caixa/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../fonts/CAIXAStd-Regular.woff\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../fonts/CAIXAStd-SemiBold.woff\",\"weight\":\"500 900\",\"style\":\"normal\"}],\"display\":\"swap\",\"variable\":\"--font-caixa-std\"}],\"variableName\":\"caixaStd\"}");
